import { render } from "./Labels.vue?vue&type=template&id=be0de6dc&scoped=true"
import script from "./Labels.vue?vue&type=script&lang=js"
export * from "./Labels.vue?vue&type=script&lang=js"

import "./Labels.vue?vue&type=style&index=0&id=be0de6dc&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be0de6dc"]])

export default __exports__